module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "praise-tit"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PRAISE FOR")])]), _vm._v(" "), _c('p', {
    staticClass: "praise-tit1"
  }, [_vm._v("DR. HAGGARD’S DISEASE")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("‘No one writes a dark epiphany like McGrath . . . The horror, as ever with Patrick McGrath, is not external, Edward Haggard becomes its locus, our trick-narrator, the voice of reason, the grimacing guardian of surprise . . . McGrath’s most chilling castaway yet, and his most enduring’ — Tom Adair in "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Scotland on Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("‘Outstanding . . . a Gothic tour de force of doomed love, unsavory secrets, morphine, disfigurement, untimely death and a physician who will not heal himself . . . The final denouement, where event and delusion combine, delivers a terrible and a brilliant coup’ — Katherine A. Powers in the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Boston Globe")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("‘Dr Haggard’s Disease")]), _vm._v(" leaves one yet again impressed by how well Patrick McGrath writes. Few novelists use language as gracefully, as effectively, as economically as he does’ — Eileen Battersby in the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Irish Times")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("‘McGrath’s brilliant design weaves delicate parallels in plot with nubbed grotesqueries of name and event to produce a seamless but richly textured psychic mystery . . . sets the neck hairs creeping’ — Katherine Dunn in the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Washington Post")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e26bbbf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/praise.vue
// module id = 57
// module chunks = 0